import script from "./TSMA.vue?vue&type=script&lang=js"
export * from "./TSMA.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__